import { c as _c } from "react/compiler-runtime";
import { useUnifiedChainSwitchAndExecute } from "../../../global-account/react/index.js";
import { isNativeToken } from "../../../anyspend/utils/token.js";
import { encodeFunctionData, erc20Abi } from "viem";
import { useCallback } from "react";
import { CryptoPaymentMethodType } from "../components/common/CryptoPaymentMethod.js";
/**
 * Hook for executing direct token transfers (same chain, same token)
 * bypassing the swap backend.
 */
export function useDirectTransfer() {
  const $ = _c(6);
  const {
    switchChainAndExecute,
    switchChainAndExecuteWithEOA,
    isSwitchingOrExecuting
  } = useUnifiedChainSwitchAndExecute();
  let t0;
  if ($[0] !== switchChainAndExecute || $[1] !== switchChainAndExecuteWithEOA) {
    t0 = async t1 => {
      const {
        chainId,
        tokenAddress,
        recipientAddress,
        amount,
        method
      } = t1;
      const isNative = isNativeToken(tokenAddress);
      const execute = method === CryptoPaymentMethodType.CONNECT_WALLET ? switchChainAndExecuteWithEOA : switchChainAndExecute;
      let txHash;
      if (isNative) {
        txHash = await execute(chainId, {
          to: recipientAddress,
          value: amount
        });
      } else {
        const transferData = encodeFunctionData({
          abi: erc20Abi,
          functionName: "transfer",
          args: [recipientAddress, amount]
        });
        txHash = await execute(chainId, {
          to: tokenAddress,
          data: transferData,
          value: BigInt(0)
        });
      }
      return txHash;
    };
    $[0] = switchChainAndExecute;
    $[1] = switchChainAndExecuteWithEOA;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const executeDirectTransfer = t0;
  let t1;
  if ($[3] !== executeDirectTransfer || $[4] !== isSwitchingOrExecuting) {
    t1 = {
      executeDirectTransfer,
      isTransferring: isSwitchingOrExecuting
    };
    $[3] = executeDirectTransfer;
    $[4] = isSwitchingOrExecuting;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}